export default __webpack_public_path__ + "static/media/BloomFoliar.b6e6a0b2.png";